import './exportable_report_view.js.coffee'
Customer.Views ||= {}
Customer.Views.Insights ||= {}

class Customer.Views.Insights.OperatorActivityReportView extends Customer.Views.Insights.ExportableReportView
  jobURL: 'operator_activity/report_job'
  infoURL: 'operator_activity/info_before_execution'
  events:
    'click #filter': '_startActivityReportJob'
    'click #activity-export-excel': '_startActivityReportExcelJob'
    'click label.radio': 'onOptionsChange'
    'keyup #search-statuses-input': 'searchStatuses'
    'keyup #search-users-input': 'searchUsers'
    'click #toggleFilter': 'onToggleFilter'
    'click #export-confirm': 'exportConfirm'

  _dataForReportJob: =>
    @selectAllRightSideUsers()
    @selectAllRightSideStatus()
    data = @$el.serializeArray()
    for param in _.filter(data, (param) -> param.name in ['from', 'to'])
      param.value = "#{param.value} #{@_getSelectedTimezone()}"
    data

  _startActivityReportJob: (event) ->
    event.preventDefault()
    @showLoadingAnimation()
    @activityReportJob(data: @_dataForReportJob()).start()

  _startActivityReportExcelJob: (event) ->
    event.preventDefault()
    @showLoadingAnimation()
    @activityReportExcelJob(data: @_dataForReportJob())

  showActivityTable: (results) =>
    @resultsView.remove() if @resultsView
    @resultsView = new Customer.Views.Insights.OperatorActivityResultsView(
      results: results
      statuses: @getStatuses(selected: true)
      timezone: @_getSelectedTimezone()
    ).render()

  searchStatuses: ->
    @_search(
      @$el.find('#operator_status_filter #leftValues'),
      @$el.find('#search-statuses-input').val()
    )

  searchUsers: ->
    @_search(
      @$el.find('#user_and_group_filter #leftValues'),
      @$el.find('#search-users-input').val()
    )

  _search: ($select, query) ->
    $select.find('option').each ->
      $(@).toggle($(@).html().toLowerCase().indexOf(query.toLowerCase()) != -1)

  getStatuses: ({selected}) =>
    selector = if selected then '#rightValues' else '#leftValues'
    statuses = @$el.find("#operator_status_filter #{selector} option").map ->
      id: @value
      name: @innerHTML.trim()
    return statuses.get() if statuses.length or selected == false
    @getStatuses selected: false

  selectedActivityType: =>
    @$('input[name=summary_type]:checked').val()

  selectAllRightSideUsers: ->
    @$('#user_and_group_filter #rightValues').find('option').prop('selected', 'selected')

  selectAllRightSideStatus: ->
    @$('#operator_status_filter #rightValues').find('option').prop('selected', 'selected')

  onOptionsChange: (event) ->
    input = $(event.currentTarget).find('input')
    inputName = input.attr('name')
    inputValue = input.attr('value')

    if inputValue == 'summary'
      input.parents('.checkbox').find("input[value="+"day"+"]").prop('checked', true)
      input.parents('.checkbox').find("input[value="+"period"+"]").prop('checked', false)
    else if inputName == 'summary_by_operator'
      input.parents('.checkbox').find("input[value="+"summary"+"]").prop('checked', true)
      input.parents('.checkbox').find("input[value="+"detail"+"]").prop('checked', false)
    else if inputValue == 'detail'
      input.parents('.checkbox').find("input[name="+"summary_by_operator"+"]").prop('checked', false)

  _getSelectedTimezone: ->
    gmt_value = @$el.find('#timezone-selector select').val()
    gmt_value.replace /GMT/, ''

  onToggleFilter: ->
    $('#filters_collapsable').toggleClass('h-0')
    $('#toggleFilter img').toggleClass('hidden')
    $('.toggleable').toggleClass('hidden')
